import { render, staticRenderFns } from "./PsychologyApppointmentTable.vue?vue&type=template&id=a977757e&"
import script from "./PsychologyApppointmentTable.vue?vue&type=script&lang=js&"
export * from "./PsychologyApppointmentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports